module.exports = __webpack_public_path__ + "static/img/fa-solid-900.81b47aa.svg";